import { render, staticRenderFns } from "./addUkey.vue?vue&type=template&id=244c695e&scoped=true"
import script from "./addUkey.vue?vue&type=script&lang=js"
export * from "./addUkey.vue?vue&type=script&lang=js"
import style0 from "./addUkey.vue?vue&type=style&index=0&id=244c695e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244c695e",
  null
  
)

export default component.exports